
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'MaintenanceInputwrap'
})
export default class MaintenanceInputwrap extends Vue {
  @Prop()
  private prefix: string;

  @Prop()
  private suffix: string;
}
